import React from "react";
import { Plus, Trash2 } from "lucide-react";

export function ExplanationBlockList({
                                  blocks,
                                  selectedBlockId,
                                  onSelect,
                                  onChange,
                                  onDelete,
                              }) {
    const addCode = () => {

        const id = `code_${crypto.randomUUID().slice(0, 6)}`;

        onChange(
            [
                ...blocks,
                {
                    id,
                    type: "code",
                    config: {
                        language: "python",
                        editable: false,
                        showCompiler: false,
                        code: "",
                    },
                },
            ],
            id
        );

    };
    const addText = () => {

        const id = `text_${crypto.randomUUID().slice(0, 6)}`;

        onChange(
            [
                ...blocks,
                {
                    id,
                    type: "text",
                    config: {
                        text: "",
                    },
                },
            ],
            id
        );

    };

    return (

        <div>

            <div className="flex gap-2 mb-4">

                <button
                    type="button"
                    onClick={addText}
                    className="px-3 py-2 rounded-lg bg-blue-600 text-white text-sm"
                >
                    + متن
                </button>

                <button
                    type="button"
                    onClick={addCode}
                    className="px-3 py-2 rounded-lg bg-blue-600 text-white text-sm"
                >
                    + کد
                </button>

            </div>

            {
                blocks.length === 0 && (
                    <div className="p-3 rounded-lg border bg-gray-50 text-sm text-gray-500">
                        هنوز بلاکی اضافه نشده است.
                    </div>
                )
            }

            <div className="space-y-2">

                {
                    blocks.map(block => (

                        <div
                            key={block.id}
                            onClick={() => onSelect(block.id)}
                            className={`cursor-pointer border rounded-xl p-3 ${
                                selectedBlockId === block.id
                                    ? "border-blue-500 bg-blue-50"
                                    : "border-gray-200 bg-white"
                            }`}
                        >

                            <div className="flex items-center justify-between">

                                <div>

                                    <div className="font-medium">
                                        {block.type === "text" ? "متن" : "کد"}
                                    </div>

                                    <div className="text-xs text-gray-500">
                                        {block.id}
                                    </div>

                                </div>

                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDelete(block.id);
                                    }}
                                    className="p-2 rounded hover:bg-red-50 text-red-600"
                                >
                                    <Trash2 size={15}/>
                                </button>

                            </div>

                        </div>

                    ))
                }

            </div>

        </div>

    );

}